// removed by extract-text-webpack-plugin
module.exports = {"content":"GoogleLoginError__content","title":"GoogleLoginError__title","message":"GoogleLoginError__message","okButton":"GoogleLoginError__okButton","growDotQello":"GoogleLoginError__growDotQello","growDotBlue":"GoogleLoginError__growDotBlue","growDotGolden":"GoogleLoginError__growDotGolden"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Popup/GoogleLoginError/GoogleLoginError.scss
// module id = 1869
// module chunks = 0